<template>
  <div>
    <div class="columns">
      <div class="column is-8 is-offset-2">
        <nav class="pagination is-centered" role="navigation" aria-label="pagination">
          <a class="pagination-previous" v-on:click="previousPage()">&larr; Prev</a>
          <a class="pagination-next" v-on:click="nextPage()">Next &rarr;</a>
          <ul class="pagination-list" v-for="p in pagination.pagelist" :key="p">
            <li>
              <a v-if="p>0" class="pagination-link" v-bind:class="{'is-current': p==pagination.page}" :aria-label="`Goto page {p}`" v-on:click="goto(p)">{{p}}</a>
              <span v-else class="pagination-ellipsis">&hellip;</span>
            </li>
          </ul>
        </nav>
      </div>
    </div>

    <div class="columns">
      <div class="column is-12 tile is-ancestor">
        <ImageTile v-for="(images, index) in columns" :key="index" v-bind:images="images"></ImageTile>
      </div>
    </div>
  </div>

</template>

<script>

import Vue from 'vue'
import axios from 'axios'
import ImageTile from '@/components/Image'

export default {
  name: 'ImageList',
  props: ['imagelist'],
  components: {
    ImageTile
  },
  data() {
    return {
      pagination: {
        perPage: 40, // = tiles.numColumns * tiles.perColumn
        page: 1,
        pages: 1,
        pagelist: []
      },
      tiles: {
        numColumns: 4,
        perColumn: 10
      }
    }
  },

  computed: {
    images() {
      // XXX need this one here
      this.updatePagination(this.pagination.page)

      return this.imagelist.slice(
        (this.pagination.page-1)*this.pagination.perPage,
        this.pagination.page*this.pagination.perPage)
    },
    columns() {
      let cols = [],
          perColumn = this.tiles.perColumn

      for (let i = 0; i < this.tiles.numColumns; i++) {
        cols.push(this.images.slice(i*perColumn, (i+1)*perColumn))
      }

      return cols
    }
  },
  methods: {
    updatePagination(page) {
      location.hash = location.hash.replace(/(\/(\d+))?$/, '/1')
      this.pagination.page = page
      this.pagination.pages = Math.ceil(this.imagelist.length / this.pagination.perPage)
      this.pagination.pagelist = [1, -1]

      let page_from = page-5, page_to = page+5;
      if (page_from <= 1) {
        page_from = 2
      }
      if (page_to >= this.pagination.pages) {
        page_to = this.pagination.pages-1
      }

      for (let p = page_from; p <= page_to; p++) {
        this.pagination.pagelist.push(p)
      }

      this.pagination.pagelist = this.pagination.pagelist.concat([-2, this.pagination.pages])
    },
    goto(page) {
      if (page > this.pagination.pages || page <= 0) {
        return
      }

      this.updatePagination(page)
    },
    nextPage() {
      this.goto(this.pagination.page+1)
    },
    previousPage() {
      this.goto(this.pagination.page-1)
    }
  },
  created() {
    let page = 1
    if (this.$route && this.$route.params.page) {
      page = parseInt(this.$route.params.page)
    }

    this.goto(page)
  }
}
</script>

<style scoped>
.pagination {
  margin-bottom: 10px;
}
.pagination-link.is-current {
    background-color: #363636;
    border-color: #363636;
    color: #fff;
}
</style>
